(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("tether"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "tether", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["TetherComponent"] = factory(require("react"), require("tether"), require("react-dom"));
	else
		root["TetherComponent"] = factory(root["React"], root["Tether"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 